export default {"src":"/_next/static/media/user-full.20b94fd4.svg","height":14,"width":14};